export default __webpack_public_path__ + "static/media/cheatday_3@3x.3b1930af.jpg";